/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type PaginationData_pageInfo$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type MessagesList_queryResult$ref: FragmentReference;
export type MessagesList_queryResult = {|
  +thread_list: ?{|
    +threads_with_unread_messages_count: ?number,
    +threads: ?$ReadOnlyArray<?{|
      +created_at: ?any,
      +created_at_str: ?string,
      +status: ?string,
      +status_string: ?string,
      +id: string,
      +ref_id: string,
      +number: ?string,
      +unread_messages_count: ?number,
      +messages: ?$ReadOnlyArray<?{|
        +attachments: ?$ReadOnlyArray<?string>,
        +attachments_object: ?$ReadOnlyArray<?{|
          +name: ?string,
          +type: ?string,
          +url_original: ?string,
          +ref_id: string,
          +id: string,
        |}>,
        +body: ?string,
        +created_at: ?any,
        +created_at_str: ?string,
        +id: string,
        +is_current_user_message: ?boolean,
        +ref_id: string,
      |}>,
      +thread_topic: ?{|
        +id: string,
        +ref_id: string,
        +title: ?string,
      |},
      +vendor: ?{|
        +logo: ?{|
          +url_original: ?string,
          +name: ?string,
        |},
        +ref_id: string,
        +id: string,
        +name: ?string,
      |},
    |}>,
    +page_info: ?{|
      +$fragmentRefs: PaginationData_pageInfo$ref
    |},
    +errors: ?$ReadOnlyArray<?{|
      +field: ?string,
      +messages: ?$ReadOnlyArray<?string>,
      +code: ?number,
    |}>,
  |},
  +$refType: MessagesList_queryResult$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created_at",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created_at_str",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url_original",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "MessagesList_queryResult",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "input",
      "type": "ThreadListInput",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "thread_list",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input",
          "type": "ThreadListInput"
        }
      ],
      "concreteType": "UserThreadInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "threads_with_unread_messages_count",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "threads",
          "storageKey": null,
          "args": null,
          "concreteType": "UserThread",
          "plural": true,
          "selections": [
            v0,
            v1,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status_string",
              "args": null,
              "storageKey": null
            },
            v2,
            v3,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "number",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "unread_messages_count",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "messages",
              "storageKey": null,
              "args": null,
              "concreteType": "UserMessage",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "attachments",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "attachments_object",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MessageAttachmentDetails",
                  "plural": true,
                  "selections": [
                    v4,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "type",
                      "args": null,
                      "storageKey": null
                    },
                    v5,
                    v0,
                    v2
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "body",
                  "args": null,
                  "storageKey": null
                },
                v1,
                v3,
                v2,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_current_user_message",
                  "args": null,
                  "storageKey": null
                },
                v0
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "thread_topic",
              "storageKey": null,
              "args": null,
              "concreteType": "UserThreadTopic",
              "plural": false,
              "selections": [
                v2,
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "vendor",
              "storageKey": null,
              "args": null,
              "concreteType": "Shop",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "logo",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "BasicImage",
                  "plural": false,
                  "selections": [
                    v5,
                    v4
                  ]
                },
                v0,
                v2,
                v4
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "page_info",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PaginationData_pageInfo",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "errors",
          "storageKey": null,
          "args": null,
          "concreteType": "Error",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "field",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "messages",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "code",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'adddba7ebb9498e9441289f35ed0934c';
module.exports = node;
